'use strict';

(function () {
  'use strict';
  // 

  angular.module('msCore').component('msPasswordStrength', {
    bindings: {
      passStrength: '<'
    },
    templateUrl: 'core/templates/msPasswordStrength.html',
    controller: ['$log', msPasswordStrengthCtrl]
  });

  function msPasswordStrengthCtrl() {
    var vm = this;
    vm.$onInit = _activate;

    vm.passStrengthMaping = {
      VERY_WEAK: 20,
      WEAK: 40,
      REASONABLE: 60,
      STRONG: 80,
      VERY_STRONG: 100

      //triggered when one-way bindings change
    };vm.$onChanges = function () {
      if (vm.passStrength) {
        vm.determinateValue = vm.passStrengthMaping[vm.passStrength];
      }
    };

    vm.getCssClass = function () {
      if (vm.passStrength === 'VERY_WEAK' || vm.passStrength === 'WEAK') {
        return 'md-warn';
      }
      return 'md-accent';
    };

    function _activate() {
      if (vm.passStrength) {
        vm.determinateValue = vm.passStrengthMaping[vm.passStrength];
      }
    }
  }
})();